import { useState } from 'react';
import { createUseStyles } from 'react-jss';
import MSFTHeader from './components/MSFTHeader';
import Intro from './components/Intro';
import Studio from './components/Studio';
import variables from './theme/variables';
import { StateProvider } from './contexts/GlobalState';
import MuteButton from './components/MuteButton';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useUHF } from './hooks/useUHF';

const useStyles = createUseStyles(
    {
        app: {
            position: 'relative',
            minHeight: 'var(--app-height)',
            background: variables.palette.grey.dark,
        },
    },
    { name: 'App' }
);

function App() {
    const classes = useStyles();
    const [state, setState] = useState('intro'); // intro | studio |

    const { cssIncludes, javascriptIncludes } = useUHF();

    const startExperience = () => {
        setState('studio');
    };

    return (
        <StateProvider>
            <HelmetProvider>
                <Helmet>
                    {cssIncludes.map((attributes, index) => (
                        <link key={index} {...attributes} />
                    ))}

                    {javascriptIncludes.map((attributes, index) => (
                        <script key={index} {...attributes}></script>
                    ))}
                </Helmet>

                <div className={classes.app}>
                    <MSFTHeader />

                    {state === 'intro' && <Intro onBegin={startExperience} />}
                    {state === 'studio' && <Studio />}
                    {state === 'studio' && <MuteButton />}
                </div>
            </HelmetProvider>
        </StateProvider>
    );
}

export default App;
